
export const CLEAN_ALL = 'CLEAN_ALL'
export const GETRECENTBUY = 'GETRECENTBUY'
export const SETTOKEN = 'SETTOKEN'
export const SETUSERNAME = 'SETUSERNAME'
export const SETUSER = 'SETUSER'
export const SETUSERDETAIL = 'SETUSERDETAIL'
export const INITUSERDETAIL = 'INITUSERDETAIL'
export const INITPOLICYDETAIL = 'INITPOLICYDETAIL'
export const SETHISTORY = 'SETHISTORY'
export const CLEARHISTORY = 'CLEARHISTORY'
export const INITCONFIG = 'INITCONFIG'
export const CONNECT_WALLET = 'CONNECT_WALLET'


// WEBPACK FOOTER //
// ./src/store/mutations-types.js